<template>
  <!-- 批量审批历史记录 -->
  <div class="batch-record-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="BATCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button @click="exportTable" type="primary">导出</a-button>
      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
        row-key="key"
      >
        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            查看
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { BATCH_SCHEMA } from './schema'
import { getBatchRecordList, exportRecord } from './api'
import { formatParamDate } from 'utils/util'

export default {
  name: 'batch-record-list',
  data() {
    const initSearchForm = {
      applyEnd: '',
      applyStart: '',
      id: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      BATCH_SCHEMA,
      initSearchForm,
      searchForm,
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableLoading: false,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          fixed: 'left',
        },
        {
          title: '流水号',
          dataIndex: 'id',
        },
        {
          title: '申请人',
          dataIndex: 'applier',
          width: 120,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          width: 150,
        },
        {
          title: '申请总金额(元)',
          dataIndex: 'totalAmount',
          width: 200,
        },
        {
          title: '最高金额(元)',
          dataIndex: 'maxAmount',
          width: 200,
        },
        {
          title: '信用类型',
          dataIndex: 'typeStr',
          width: 180,
        },
        {
          title: '我的审批意见',
          dataIndex: 'statusStr',
          width: 120,
        },
        {
          title: '当前流程状态',
          dataIndex: 'bpStatus',
          width: 120,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      SCROLL: { x: 1700 },
    }
  },
  mounted() {
    this._getBatchRecordList(this.initSearchForm)
  },
  methods: {
    async _getBatchRecordList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getBatchRecordList(formData)
        this.pageData.total = total
        this.tableData = records.map(item => {
          item.key = `${item.id}_${item.approveDate}`
          return item
        })
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      data = formatParamDate(
        data,
        data.applyRangeDate,
        'applyStart',
        'applyEnd',
      )
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getBatchRecordList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getBatchRecordList(this.searchForm)
    },
    handleView(row) {
      const { id } = row
      this.$router.push({
        name: 'batch-approval-detail',
        params: { bpmId: id },
        query: { type: 8 },
      })
    },
    exportTable() {
      const params = {
        ...this.searchForm,
      }
      exportRecord(params)
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
